// modules/inicio/components/ErrorBoundary.js
// Primera pieza del manejo de errores "modo PWA": si un componente cualquiera
// de la app truena en render (no en una llamada de red — eso lo maneja cada
// pantalla por su cuenta), esto evita la pantalla en blanco total y ofrece
// recargar, en vez de dejar la app muerta sin explicación.

import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // TODO: cuando haya servicio de logging remoto, mandar esto allá también.
    console.error("💥 Error no controlado en la interfaz:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-center px-3"
        style={{ minHeight: "60vh" }}>
        <div style={{ fontSize: "2.5rem", marginBottom: 8 }}>⚠️</div>
        <h4 style={{ color: "#1a3a5c", fontWeight: 700 }}>Algo salió mal</h4>
        <p className="text-muted" style={{ maxWidth: 420, fontSize: "0.9rem" }}>
          Ocurrió un error inesperado en esta pantalla. Puedes intentar recargar —
          si el problema sigue, avísale al soporte técnico.
        </p>
        <button
          className="btn"
          style={{ background: "#1a3a5c", color: "#fff", border: "none", padding: "8px 20px", borderRadius: 8 }}
          onClick={() => window.location.reload()}
        >
          Recargar página
        </button>
      </div>
    );
  }
}
